import CharacterCount from './CharacterCount'
import type Draft from '../entities/Draft/Draft'
import { DraftMethods } from '../entities/Draft/DraftMethods'

import styles from './css/Composer.module.css'

import type { JSX } from 'react'

export const CharacterHashtagCountView = ({
  draft,
  isExpanded,
}: {
  draft: Draft
  isExpanded: boolean
}): JSX.Element | null => {
  const captionHashtagCount = draft.getNumberOfHashtagsInText()
  const shouldShowHashtagCount =
    isExpanded &&
    draft.service.isInstagram() &&
    draft.service.maxHashtags !== null &&
    draft.service.maxHashtags - captionHashtagCount <= 10 &&
    captionHashtagCount <= draft.service.maxHashtags

  const shouldShowCharacterCount =
    isExpanded && draft.canType() && draft.canTypeMoreCharacters()

  const hasCount = shouldShowCharacterCount || shouldShowHashtagCount
  const combinedClassName = `${styles.characterCountWrapper} ${draft.service.name}-composer-character-counter`

  if (hasCount) {
    return (
      <div className={combinedClassName}>
        {shouldShowCharacterCount && (
          <CharacterCount
            count={draft.characterCount}
            maxCount={DraftMethods.getCharLimit(draft) || 0}
          />
        )}
        {shouldShowHashtagCount && draft.service.maxHashtags && (
          <CharacterCount
            count={captionHashtagCount}
            maxCount={draft.service.maxHashtags}
            type="hashtag"
          />
        )}
      </div>
    )
  }

  return null
}
